module.exports = __webpack_public_path__ + "static/media/stick.8d13367c.png";